interface EthereumIconProps {
  className?: string
  size?: number
  colored?: boolean
}

export const EthereumIcon: React.FC<EthereumIconProps> = ({
  className,
  size = 24,
  colored = false,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 785 1298"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M392.07 1297.38L0 744.891L392.07 976.521L784.37 744.891L392.07 1297.38ZM784.129 650.54L392.07 882.29L0 650.54L392.07 0L784.129 650.54Z"
        fill={colored ? '#627EEA' : 'currentColor'}
      />
    </svg>
  )
}
